import { format } from 'date-fns';

export function formatDateDays(date: Date) {
  return format(date, 'yyyy-MM-dd');
}

export function formatDateSeconds(date: Date) {
  return format(date, 'yyyy-MM-dd_HH-mm-ss');
}
